import { useAuditLog } from '@/services/audit';
import { nb } from '@/i18n/nb';
import s from '../admin.module.css';

export function AdminAuditLog() {
  const { data: entries = [] } = useAuditLog();

  return (
    <div>
      <div className={s.head}>
        <div>
          <h2 className={s.title}>{nb.admin.auditLog.title}</h2>
          <p className={s.lede}>{nb.admin.auditLog.lede}</p>
        </div>
      </div>

      {entries.length === 0 ? (
        <p className={s.hint}>{nb.admin.auditLog.empty}</p>
      ) : (
        <div className={s.auditList}>
          {entries.map((entry) => (
            <div key={entry.id} className={s.auditRow}>
              <div className={s.auditTop}>
                <span className={s.auditAction}>{entry.action}</span>
                <span className={s.auditWhen}>{formatDateTime(entry.when)}</span>
              </div>
              <div className={s.auditEntity}>
                {entry.entityType} · {entry.entityId}
              </div>
              <div className={s.auditMeta}>{entry.actor}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function formatDateTime(iso: string): string {
  return new Date(iso).toLocaleString('nb-NO', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
